// Storage keys
const STORAGE_KEYS = {
  ACCESS_TOKEN: 'skjold_access_token',
  SELECTED_PARTNER: 'skjold_selected_partner',
  ARTICLES: 'skjold_articles',
  USER_LOGGED: 'skjold_user_logged',
  AI_CONSENT_GIVEN: 'skjold_ai_consent_given',
};

// Token storage
export const saveAccessToken = (token: string): void => {
  try {
    localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token);
  } catch (error) {
    console.error('Error saving access token:', error);
  }
};

export const getAccessToken = (): string | null => {
  try {
    return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
  } catch (error) {
    console.error('Error getting access token:', error);
    return null;
  }
};

export const removeAccessToken = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
  } catch (error) {
    console.error('Error removing access token:', error);
  }
};

// Partner storage
export const saveSelectedPartner = (partner: string): void => {
  try {
    localStorage.setItem(STORAGE_KEYS.SELECTED_PARTNER, partner);
  } catch (error) {
    console.error('Error saving selected partner:', error);
  }
};

export const getSelectedPartner = (): string | null => {
  try {
    return localStorage.getItem(STORAGE_KEYS.SELECTED_PARTNER);
  } catch (error) {
    console.error('Error getting selected partner:', error);
    return null;
  }
};

export const removeSelectedPartner = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEYS.SELECTED_PARTNER);
  } catch (error) {
    console.error('Error removing selected partner:', error);
  }
};

// Articles storage
export const saveArticles = (articles: any[]): void => {
  try {
    localStorage.setItem(STORAGE_KEYS.ARTICLES, JSON.stringify(articles));
  } catch (error) {
    console.error('Error saving articles:', error);
  }
};

export const getArticles = (): any[] | null => {
  try {
    const articlesJson = localStorage.getItem(STORAGE_KEYS.ARTICLES);
    return articlesJson ? JSON.parse(articlesJson) : null;
  } catch (error) {
    console.error('Error getting articles:', error);
    return null;
  }
};

export const removeArticles = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEYS.ARTICLES);
  } catch (error) {
    console.error('Error removing articles:', error);
  }
};

// User logged tracking (to ensure we only log active user once per session)
export const isUserLogged = (): boolean => {
  try {
    return sessionStorage.getItem(STORAGE_KEYS.USER_LOGGED) === 'true';
  } catch (error) {
    console.error('Error checking user logged status:', error);
    return false;
  }
};

export const markUserAsLogged = (): void => {
  try {
    sessionStorage.setItem(STORAGE_KEYS.USER_LOGGED, 'true');
  } catch (error) {
    console.error('Error marking user as logged:', error);
  }
};

// AI consent storage
export const getAIConsentGiven = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEYS.AI_CONSENT_GIVEN) === 'true';
  } catch (error) {
    console.error('Error getting AI consent:', error);
    return false;
  }
};

export const saveAIConsentGiven = (): void => {
  try {
    localStorage.setItem(STORAGE_KEYS.AI_CONSENT_GIVEN, 'true');
  } catch (error) {
    console.error('Error saving AI consent:', error);
  }
};

// Clear all storage
export const clearAllStorage = (): void => {
  try {
    Object.values(STORAGE_KEYS).forEach((key) => localStorage.removeItem(key));
    sessionStorage.removeItem(STORAGE_KEYS.USER_LOGGED);
  } catch (error) {
    console.error('Error clearing storage:', error);
  }
};
